import { render, staticRenderFns } from "./channelApply.vue?vue&type=template&id=1c9df2f4&scoped=true&"
import script from "./channelApply.vue?vue&type=script&lang=ts&"
export * from "./channelApply.vue?vue&type=script&lang=ts&"
import style0 from "./channelApply.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./channelApply.vue?vue&type=style&index=1&id=1c9df2f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9df2f4",
  null
  
)

export default component.exports